<template>
  <nav>
    <ul class="pagination">
      <li class="page-item" :class="{disabled: this.data.current_page == 1}">
        <a class="page-link" href="javascript: void(0)" @click="onChangePage(this.data.current_page - 1)"><i class='bx bx-chevrons-left'></i></a>
      </li>
      <li class="page-item" @click="onChangePage(i)" :class="{active: i == data.current_page}" v-for="i in data.last_page" :key="i">
        <a class="page-link" href="javascript: void(0)">{{ i }}</a>
      </li>
      <li class="page-item" :class="{disabled: this.data.current_page == data.last_page}">
        <a class="page-link" href="javascript: void(0)" @click="onChangePage(this.data.current_page + 1)"><i class='bx bx-chevrons-right' ></i></a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: ['data'],

  data(){
    return {};
  },

  methods: {
    onChangePage(i){
      if (this.data.current_page == i || i < 1 || i > this.data.last_page) return;
      this.$emit('change', i);
    }
  },
}
</script>